import { normalizeExcelHeader } from './normalizeExcelHeader';

/**
 * Mirrors xlsx sheet_to_json duplicate header suffixing:
 * NOTA, NOTA_1, NOTA_2, ...
 */
export const disambiguateExcelHeaders = (
  rawHeaders: (string | number | null | undefined)[]
): string[] => {
  const occurrenceCount = new Map<string, number>();

  return rawHeaders.map((header) => {
    const normalizedHeader = normalizeExcelHeader(String(header ?? ''));

    if (!normalizedHeader) return '';

    const count = occurrenceCount.get(normalizedHeader) || 0;
    occurrenceCount.set(normalizedHeader, count + 1);

    if (count === 0) return normalizedHeader;

    return `${normalizedHeader}_${count}`;
  });
};
